













































































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import WorkItemEntity from '@/domain/work-item/work-item.entity';
import ChildListBullet from '@/assets/images/child-list-bullet.png';
import WorkItemRelated from '@/domain/work-item/work-item-related.entity';
import WorkItemModalState from '@/domain/work-item/work-item-modal-state.entity';
import WorkItemModalActions from './work-item-modal-actions.enum';
import WorkItemPut from '@/domain/work-item/work-item-put.entity';
import WorkItemDetailed from '@/domain/work-item/work-item-detailed.entity';
import WorkItemDefinitionType from './work-item-definition-type.enum';
import FilterFields from '@/domain/project/filter-fields.entity';
import WorkItemService from '@/domain/work-item/work-item.service';

@Component({
  components: {
    WorkItemModal: () => import('./work-item-modal.component.vue'),
  },
})
export default class WorkItemChildList extends Vue {
  @Prop() children!: WorkItemEntity;

  @Prop({ type: String, default: '' }) projectId !: string;

  @Prop() parentWorkItems!: WorkItemRelated[];

  @Prop() workItemAction!: any;

  @Prop() filterFields!: FilterFields;

  @Prop() workitemParentOriginSystem!: string;

  images: any = {
    bullet: ChildListBullet,
  }

  dialog: boolean = false;

  modalFields: WorkItemModalState = new WorkItemModalState(
    WorkItemModalActions.VIEW, WorkItemDefinitionType.TASK,
  );

  saveWorkItemLoading: boolean = false;

  relatedWorkItem: any = null;

  workItemTypeSelected: string = '';

  formatDateTimeOrDayOfWeek(dateTime: string): string {
    const dateTimeMoment = moment(dateTime);
    if (moment().isSame(dateTimeMoment, 'week')) {
      moment.locale(this.$i18n.locale);
      return `${dateTimeMoment.format('dddd')}, ${dateTimeMoment.format('HH:mm')}`;
    }
    return dateTimeMoment.format('DD/MM/YYYY HH:mm');
  }

  getWorkItemErroPromise(workitem: WorkItemEntity): Promise<any> {
    if (this.workitemParentOriginSystem === 'VSTS') {
      return WorkItemService.getWorkItemErrorsByTitle(this.projectId, workitem.title);
    }
    return WorkItemService.getWorkItemErrors(this.projectId, workitem.id);
  }

  openWorkitemDetails(workitem: WorkItemEntity): void {
    const promises = [
      WorkItemService.getOneWorkItemById(this.projectId, workitem.id),
      this.getWorkItemErroPromise(workitem),
    ];

    // @ts-ignore
    Promise.allSettled(promises).then((results: any) => {
      const workItem = this.workItemAction === 'UPDATE'
        // @ts-ignore
        ? WorkItemPut.of(results[0].value)
        // @ts-ignore
        : WorkItemDetailed.of(results[0].value);
      const definitionType = workItem.workItemType.definitionType === 'TASK'
        ? WorkItemDefinitionType.TASK
        : WorkItemDefinitionType.AGGREGATOR;
      if (results[1] && results[1].status === 'fulfilled') {
        // @ts-ignore
        workItem.error = results[1].value.data.error;
        // @ts-ignore
        workItem.errorId = results[1].value.data.errorId;
      }

      this.relatedWorkItem = workItem;
      this.modalFields = this.getModalState(
        workItem,
        this.workItemAction,
        workItem.workItemType.definitionType,
      );
      this.workItemTypeSelected = workItem.workItemType.definitionType;
      this.dialog = true;
    });
  }

  getModalState(
    workItem: WorkItemDetailed | WorkItemPut,
    action: string, type: string,
  ): WorkItemModalState {
    if (workItem.status === 'DONE' && workItem.originSystem === 'VSTS') {
      return WorkItemModalState.ofVstsWorkItem(action, type);
    }
    return WorkItemModalState.of(action, type);
  }

  closeModal(): void {
    this.dialog = false;
  }

  saveWorkItem(form: any): void {
    this.saveWorkItemLoading = true;
    WorkItemService.saveWorkItem(this.projectId, form)
      .then((response: any) => {
        if (response && response.status === 200) {
          this.closeModal();
        }
      }).catch((err: any) => console.log(err))
      .finally(() => this.saveWorkItemLoading = false);
  }

  getStatusColor(status: string): string {
    const statusColors: Record<string, string> = {
      Open: '#4492DB',
      Deleted: '#6C6C6C',
      Canceled: '#B20106',
      Done: '#3FAF28',
    };

    return statusColors[status] || '#4492DB';
  }
}
